import { render, staticRenderFns } from "./feedback-list.vue?vue&type=template&id=3f0f5e72&scoped=true&"
import script from "./feedback-list.vue?vue&type=script&lang=js&"
export * from "./feedback-list.vue?vue&type=script&lang=js&"
import style0 from "./feedback-list.vue?vue&type=style&index=0&id=3f0f5e72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0f5e72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VDataTable,VIcon,VSpacer,VTextField,VTooltip})
